export default __webpack_public_path__ + "static/media/lobsters.bc8ec85b.webm";